import {DynamicOrderingModuleConfig} from "./dynamic-ordering.module.config";
import {OrderToggleComponent} from "./components/order-toggle.component";
import {OrderingListComponent} from "./ordering-list/ordering-list.component";

DynamicOrderingModuleConfig.createNewModule()
    .component('orderToggle', OrderToggleComponent.instance)
    .component('orderingList', OrderingListComponent.instance);